import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Grid,
  Typography,
  Button,
  Box,
  useMediaQuery,
} from '@mui/material';
// import { Pendingwarning } from "component/BuyersMarketplace/marketplaceicons";
import { poppins400, poppins500 } from 'theme/common.style';
import Loading from 'assets/images/loading.png';
import CommonPdfViewer from 'component/Common/CommonPdfViewer';

export const Pendingwarning = () => {
  return (
    <svg
      width="38"
      height="30"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.5"
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.9607L21.3085 11.956C20.7883 11.0551 19.8271 10.5 18.7866 10.5C17.7462 10.5 16.7851 11.0551 16.2648 11.956L10.3902 22.132C9.86994 23.0329 9.86994 24.1431 10.3902 25.044C10.9104 25.9449 11.8715 26.5 12.912 26.5H24.6614C24.6646 26.5 24.6677 26.5 24.6677 26.5C26.276 26.5 27.5797 25.1962 27.5797 23.588C27.5797 22.9853 27.3957 22.4239 27.0817 21.9607ZM20.0333 22.9345C20.0333 23.6229 19.5036 24.1495 18.7898 24.1495C18.0761 24.1495 17.5464 23.6229 17.5464 22.9345V22.906C17.5464 22.2208 18.0761 21.6911 18.7898 21.6911C19.5036 21.6911 20.0333 22.2177 20.0333 22.906V22.9345ZM20.0619 14.7443L19.4465 20.1178C19.4052 20.5048 19.1483 20.7458 18.7898 20.7458C18.4314 20.7458 18.1745 20.5016 18.1332 20.1178L17.5178 14.7411C17.4766 14.3255 17.7019 14.0115 18.0888 14.0115H19.4877C19.8747 14.0147 20.1031 14.3287 20.0619 14.7443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

const AcceptanceCertificateDialog = ({
  open,
  onClose,
  vendorHistoryData,
  profileDetails,
  privateoffer,
  selectedRowIndex,
}) => {
  const matchessm = useMediaQuery('(max-width:600px)');
  const [pdfEmbedUrl, setPdfEmbedUrl] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  // useEffect(() => {
  //   const fileFromAPI =
  //     privateoffer?.signedFile

  //   if (fileFromAPI) {
  //     setPdfLoading(true);
  //     const embedUrl = `${fileFromAPI}#toolbar=0`;
  //     setPdfEmbedUrl(embedUrl);

  //     setTimeout(() => setPdfLoading(false), 2000); // simulate loading
  //   } else {
  //     setPdfEmbedUrl(null);
  //     setPdfLoading(false);
  //   }
  // }, [privateoffer]);

  useEffect(() => {
    const selectedFile = vendorHistoryData?.[selectedRowIndex]?.signedFile;

    if (selectedFile) {
      setPdfLoading(true);
      const embedUrl = `${selectedFile}#toolbar=0`;
      setPdfEmbedUrl(embedUrl);
      setTimeout(() => setPdfLoading(false), 2000);
    } else {
      setPdfEmbedUrl(null);
      setPdfLoading(false);
    }
  }, [selectedRowIndex, vendorHistoryData]);

  const address = profileDetails?.PropertyDetails?.propertyAddress || {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '100%' : '650px',
          boxShadow: '-4px 4px rgba(0, 0, 0, 0.09)',
          padding: '30px',
          overflow: 'hidden',
        },
      }}
    >
      <Grid container height="100%">
        <Grid item xs={12}>
          <Typography
            sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
          >
            {address.streetName}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          display="flex"
          alignItems="center"
          padding="10px 0px"
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '20px' : '24px',
              paddingLeft: '12px',
            }}
          >
            Acceptance Certificate
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <div style={{ width: '100%', height: '780px' }}>
            {pdfLoading ? (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  alt="Loading"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '75px', width: '75px' }}
                />
              </Box>
            ) : pdfEmbedUrl ? (
              <CommonPdfViewer fileUrl={pdfEmbedUrl} />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <p>No PDF file available</p>
              </Box>
            )}
          </div>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent={matchessm ? 'center' : 'flex-end'}
          gap={2}
          marginTop={2}
        >
          <Grid item>
            <Button
              variant="outlined"
              style={{
                padding: '10px 39px',
                height: '41px',
                fontSize: '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={onClose}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default AcceptanceCertificateDialog;
